module.exports = __webpack_public_path__ + "static/media/nav-icon-feedback.ac8ea213.svg";